import { useState, useEffect } from 'react';
import { LOCAL_VERSION } from '../version';

export function useCheckVersion({ intervalMs = 5 * 60 * 1000 } = {}) {
  const [isStale, setIsStale] = useState(false);

  useEffect(() => {
    let timerId;

    async function check() {
      try {
        const res = await fetch('/meta.json', { cache: 'no-store' });
        if (!res.ok) throw new Error('não foi possível carregar meta.json');
        const { version: remoteVersion } = await res.json();
        if (remoteVersion !== LOCAL_VERSION) {
          setIsStale(true);
          clearInterval(timerId);
        }
      } catch (err) {
        console.error('Erro ao verificar versão:', err);
      }
    }

    // check imediatamente, e depois a cada intervalMs
    check();
    timerId = setInterval(check, intervalMs);

    return () => clearInterval(timerId);
  }, [intervalMs]);

  return isStale;
}